import { useCallback, useEffect } from 'react'
import { fetchWithCheckAuthorization } from 'utils/fetchWithAuthorization'
import { APIMe } from 'interfaces/API'
import Utilisateur from 'entity/Utilisateur'
import { useAppDispatch, useAppSelector } from 'redux/hooks'
import {
  error,
  loading,
  succeeded,
  Status,
} from 'redux/features/utilisateur/slice'
import { useLocation } from 'react-router-dom'
import {
  makeSelectStatus,
  makeSelectUtilisateur,
  makeSelectErrorMsg,
} from 'redux/features/utilisateur/selectors'

interface ReturnProps {
  utilisateur: Utilisateur | null
  errorMsg: string | null
  status: Status
  checkUtilisateurAutorise: (page?: string) => boolean
}

const useUtilisateur = (): ReturnProps => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const utilisateur = useAppSelector(makeSelectUtilisateur)
  const errorMsg = useAppSelector(makeSelectErrorMsg)
  const status = useAppSelector(makeSelectStatus)

  const fetchUtilisateur = useCallback(async () => {
    try {
      dispatch(loading())
      const response = await fetchWithCheckAuthorization('/api/me')
      if (!response.ok) throw Error(response.statusText)
      const json: APIMe = await response.json()

      dispatch(
        succeeded(
          new Utilisateur(
            json.name,
            json.surname,
            json.roles,
            json.fenetresAide
          )
        )
      )
    } catch (err: unknown) {
      console.error(err)
      dispatch(error((err as Error).toString()))
    }
  }, [dispatch])

  useEffect(() => {
    if (utilisateur === null) {
      fetchUtilisateur()
    }
  }, [utilisateur, fetchUtilisateur])

  const checkUtilisateurAutorise = (page?: string): boolean => {
    let pageAVerifier = page
    if (page === undefined) {
      pageAVerifier = location.pathname
    }
    if (utilisateur === null) {
      return false
    }
    switch (pageAVerifier) {
      case '/biens-a-vendre':
        return utilisateur.roles.includes(
          'ROLE_CONSEILLER_AUTORISE_RECHERCHE_BIEN'
        )
      default:
        return false
    }
  }

  return { utilisateur, errorMsg, status, checkUtilisateurAutorise }
}

export default useUtilisateur
